export { QuestionIcon } from './question'
